import messages from '../lib/messages.json';

const infoFeatures = [
  {
    id: 'features',
    href: 'https://fashionunited.info/fashionunited-news',
    router: true,
    route: 'fashionunited-news',
    items: [
      {
        id: 'info.features.news',
        href: 'https://fashionunited.info/fashionunited-news',
        router: true,
        route: 'fashionunited-news',
      },
      {
        id: 'info.features.newsletter',
        href: 'https://fashionunited.info/fashionunited-newsletter',
        router: true,
        route: 'fashionunited-newsletter',
      },
      {
        id: 'info.features.careerCenter',
        href: 'https://fashionunited.info/fashionunited-career-center',
        router: true,
        route: 'fashionunited-career-center',
      },
      {
        id: 'info.features.fashionWeekWeb',
        href: 'https://fashionunited.info/fashionweekweb',
        router: true,
        route: 'fashionweekweb',
      },
      {
        id: 'info.features.media',
        href: 'https://fashionunited.info/fashion-united-media',
        router: true,
        route: 'fashion-united-media',
      },
      {
        id: 'info.features.companyDirectory',
        href: 'https://fashionunited.info/companydirectory',
        router: true,
        route: 'companydirectory',
      },
      {
        id: 'info.features.education',
        href: 'https://fashionunited.info/fashion-education-network',
        router: true,
        route: 'fashion-education-network',
      },
    ],
  },
];

const infoLinks = [
  {
    id: 'info',
    router: true,
    route: 'index',
    items: [
      {
        id: 'argentina',
        href: 'https://fashionunited.com.ar/',
        router: false,
      },
      {
        id: 'australia',
        href: 'https://au.fashionunited.com/',
        router: false,
      },
      {
        id: 'austria',
        href: 'https://fashionunited.at/',
        router: false,
      },
      {
        id: 'belgiumNl',
        href: 'https://fashionunited.be/',
        router: false,
      },
      {
        id: 'belgiumFr',
        href: 'https://fashionunited.be/fr',
        router: false,
      },
      {
        id: 'brazil',
        href: 'https://fashionunited.com.br/',
        router: false,
      },
      {
        id: 'canadaEn',
        href: 'https://fashionunited.ca/',
        router: false,
      },
      {
        id: 'canadaFr',
        href: 'https://fashionunited.ca/fr',
        router: false,
      },
      {
        id: 'chile',
        href: 'https://fashionunited.cl/',
        router: false,
      },
      {
        id: 'china',
        href: 'https://cn.fashionunited.com/',
        router: false,
      },
      {
        id: 'colombia',
        href: 'https://fashionunited.co/',
        router: false,
      },
      {
        id: 'czechia',
        href: 'https://fashionunited.cz/',
        router: false,
      },
      {
        id: 'denmark',
        href: 'https://fashionunited.dk/',
        router: false,
      },
      {
        id: 'finland',
        href: 'https://fashionunited.fi/',
        router: false,
      },
      {
        id: 'france',
        href: 'https://fashionunited.fr/',
        router: false,
      },
      {
        id: 'germany',
        href: 'https://fashionunited.de/',
        router: false,
      },
      {
        id: 'hongKong',
        href: 'https://fashionunited.hk/',
        router: false,
      },
      {
        id: 'hungary',
        href: 'https://fashionunited.hu/',
        router: false,
      },
      {
        id: 'india',
        href: 'https://fashionunited.in/',
        router: false,
      },
      {
        id: 'ireland',
        href: 'https://fashionunited.ie/',
        router: false,
      },
      {
        id: 'italy',
        href: 'https://fashionunited.it/',
        router: false,
      },
      {
        id: 'japan',
        href: 'https://fashionunited.jp/',
        router: false,
      },
      {
        id: 'luxembourg',
        href: 'https://fashionunited.lu/',
        router: false,
      },
      {
        id: 'mexico',
        href: 'https://fashionunited.mx/',
        router: false,
      },
      {
        id: 'theNetherlands',
        href: 'https://fashionunited.nl/',
        router: false,
      },
      {
        id: 'newZealand',
        href: 'https://fashionunited.nz/',
        router: false,
      },
      {
        id: 'norway',
        href: 'https://fashionunited.no/',
        router: false,
      },
      {
        id: 'peru',
        href: 'https://fashionunited.com.pe/',
        router: false,
      },
      {
        id: 'poland',
        href: 'https://fashionunited.pl/',
        router: false,
      },
      {
        id: 'portugal',
        href: 'https://fashionunited.pt/',
        router: false,
      },
      {
        id: 'russia',
        href: 'https://ru.fashionunited.com/',
        router: false,
      },
      {
        id: 'spain',
        href: 'https://fashionunited.es/',
        router: false,
      },
      {
        id: 'sweden',
        href: 'https://fashionunited.se/',
        router: false,
      },
      {
        id: 'switzerland',
        href: 'https://fashionunited.ch/',
        router: false,
      },
      {
        id: 'turkey',
        href: 'https://fashionunited.com.tr/',
        router: false,
      },
      {
        id: 'unitedKingdom',
        href: 'https://fashionunited.uk/',
        router: false,
      },
      {
        id: 'unitedStates',
        href: 'https://fashionunited.com/',
        router: false,
      },
    ],
  },
];

const getSharedLinks = (intl, router) => (
  [
    {
      id: 'category.news.fashion',
      href: intl.formatMessage(
        messages['category.news.fashion.href'],
      ),
      router,
      route: 'category',
      params: {
        categoryPath: intl.formatMessage(
          messages['category.news.fashion.param'],
        ),
      },
    },
    {
      id: 'category.news.retail',
      href: intl.formatMessage(
        messages['category.news.retail.href'],
      ),
      router,
      route: 'category',
      params: {
        categoryPath: intl.formatMessage(
          messages['category.news.retail.param'],
        ),
      },
    },
    {
      id: 'category.news.business',
      href: intl.formatMessage(
        messages['category.news.business.href'],
      ),
      router,
      route: 'category',
      params: {
        categoryPath: intl.formatMessage(
          messages['category.news.business.param'],
        ),
      },
    },
    {
      id: 'category.news.culture',
      href: intl.formatMessage(
        messages['category.news.culture.href'],
      ),
      router,
      route: 'category',
      params: {
        categoryPath: intl.formatMessage(
          messages['category.news.culture.param'],
        ),
      },
    },
    {
      id: 'category.news.people',
      href: intl.formatMessage(
        messages['category.news.people.href'],
      ),
      router,
      route: 'category',
      params: {
        categoryPath: intl.formatMessage(
          messages['category.news.people.param'],
        ),
      },
    },
    {
      id: 'category.news.fairs',
      href: intl.formatMessage(
        messages['category.news.fairs.href'],
      ),
      router,
      route: 'category',
      params: {
        categoryPath: intl.formatMessage(
          messages['category.news.fairs.param'],
        ),
      },
    },
  ]
);

export {
  getSharedLinks,
  infoFeatures,
  infoLinks,
};
